import React, { forwardRef, useState, useRef, useImperativeHandle, useEffect } from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Input } from '@mui/material';
import reportslogo from "../../../assets/images/reportslogo.png";
import { DefaultCard } from '../../../assets/styled-components/card';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { useReactToPrint } from 'react-to-print';
import SignaturePad from './SignaturePad';
import axios from 'axios';
import { BemsGraph } from '../../../utility/apiURLS';
import { getAuthToken, getcompanyId, getFacilityId, getuserId } from '../../../utility/tokenUtility';
import PageLoader from '../../commoncomponents/PageLoader';
import dayjs from 'dayjs';
import customParseFormat from "dayjs/plugin/customParseFormat"

const ViewAssetMedicalRiskManagment = forwardRef(({ data }, ref) => {
    const printRef = useRef();

    const token = getAuthToken("id_token");
    const userId = getuserId("userId");
    const companyId = getcompanyId("companyId");
    const facilityId = getFacilityId("facilityId");
    const [loading, setLoading] = useState(false);
    const [riskrowsdata, setRiskRowsData] = useState([]);
    const [documentid, setDocumentId] = useState('');
    // --- Dynamic Form Control Field States ---
    const [analysisText, setAnalysisText] = useState("");
    const [actionText, setActionText] = useState("");
    const [recommendationText, setRecommendationText] = useState("");
    const [preparedSignature, setPreparedSignature] = useState("");
    const [verifiedSignature, setVerifiedSignature] = useState("");
 
    const [implications, setImplications] = useState({
        0: "",
        1: "",
        2: "",
        3: ""
    });

    // Signature Panel Inputs 
    const [preparedByName, setPreparedByName] = useState("");
    const [preparedByDesignation, setPreparedByDesignation] = useState("");
    const [preparedByDate, setPreparedByDate] = useState("");

    const [verifiedByName, setVerifiedByName] = useState("");
    const [verifiedByDesignation, setVerifiedByDesignation] = useState("");
    const [verifiedByDate, setVerifiedByDate] = useState("");

    const {
        quarter: quarterObj,
        year: yearObj,
        hospital: hospitalObj,
        editform
    } = data || {};

    useEffect(() => {
        if (data) {
            fetchchecklist();
        }
    }, [data]);

    // Dashboard Percentage Computations
    const totalassetage = riskrowsdata?.assetoneyear + riskrowsdata?.assetFive + riskrowsdata?.assetTenyear + riskrowsdata?.assetFifteenyear + riskrowsdata?.asssetTwentyYear + riskrowsdata?.assetGreaterthanTwentyYear || 0;
    const oneyear = totalassetage > 0 ? `${((riskrowsdata?.assetoneyear / totalassetage) * 100).toFixed(2)} %` : "0 %";
    const fiveyear = totalassetage > 0 ? `${((riskrowsdata?.assetFive / totalassetage) * 100).toFixed(2)} %` : "0 %";
    const tenyear = totalassetage > 0 ? `${((riskrowsdata?.assetTenyear / totalassetage) * 100).toFixed(2)} %` : "0 %";
    const fifteenyear = totalassetage > 0 ? `${((riskrowsdata?.assetFifteenyear / totalassetage) * 100).toFixed(2)} %` : "0 %";
    const twentyyear = totalassetage > 0 ? `${((riskrowsdata?.asssetTwentyYear / totalassetage) * 100).toFixed(2)} %` : "0 %";
    const greaterthanTwentyYear = totalassetage > 0 ? `${((riskrowsdata?.assetGreaterthanTwentyYear / totalassetage) * 100).toFixed(2)} %` : "0 %";

    const totalassetsummary = riskrowsdata?.highAssetRiskcount + riskrowsdata?.moderateAssetRiskcount + riskrowsdata?.lowAssetRiskcount + riskrowsdata?.undefinedRiskcount || 0;
    const highrisk = totalassetsummary > 0 ? `${((riskrowsdata?.highAssetRiskcount / totalassetsummary) * 100).toFixed(2)} %` : "0 %";
    const moderaterisk = totalassetsummary > 0 ? `${((riskrowsdata?.moderateAssetRiskcount / totalassetsummary) * 100).toFixed(2)} %` : "0 %";
    const lowrisk = totalassetsummary > 0 ? `${((riskrowsdata?.lowAssetRiskcount / totalassetsummary) * 100).toFixed(2)} %` : "0 %";
    const undefinedrisk = totalassetsummary > 0 ? `${((riskrowsdata?.undefinedRiskcount / totalassetsummary) * 100).toFixed(2)} %` : "0 %";

    const totalconditionsummary = riskrowsdata?.highGoodRiskcount + riskrowsdata?.highFairRiskCcount + riskrowsdata?.highPoorRiskCcount + riskrowsdata?.undefinedAssetConditioncount || 0;
    const highconditionrisk = totalconditionsummary > 0 ? `${((riskrowsdata?.highGoodRiskcount / totalconditionsummary) * 100).toFixed(2)} %` : "0 %";
    const moderateconditionrisk = totalconditionsummary > 0 ? `${((riskrowsdata?.highFairRiskCcount / totalconditionsummary) * 100).toFixed(2)} %` : "0 %";
    const lowconditionrisk = totalconditionsummary > 0 ? `${((riskrowsdata?.highPoorRiskCcount / totalconditionsummary) * 100).toFixed(2)} %` : "0 %";
    const undefinedconditionrisk = totalconditionsummary > 0 ? `${((riskrowsdata?.undefinedAssetConditioncount / totalconditionsummary) * 100).toFixed(2)} %` : "0 %";

    // --- WORKFLOW Scenario 1 & 2: FETCH CHECKLIST DATA FROM SERVER ---
    const fetchchecklist = async () => {
        setLoading(true);
        try {
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const payload = {
                Userid: userId,
                Companyid: companyId,
                HospitalId: data?.hospital === "" || !data?.hospital
                    ? "00000000-0000-0000-0000-000000000000"
                    : data?.hospital?.facilityId,
                Assetconditionid: data?.assetcondition?.id,
                Quarter: data?.quarter?.value,
                Year: data?.year?.value,
                Token: token
            };

            const response = await axios.get(
                `${BemsGraph}/api/AssetReport/GetAssetMedicalDeviceRiskAssessmentlist`,
                { params: payload, ...config }
            );

            const responseData = response.data?.bemsAssetMedicalDevicelistVMs?.[0] || {};
            setRiskRowsData(responseData);
            setDocumentId(responseData?.id);
            // Bind values if present (Scenario 2), otherwise clear input states for manual input entry (Scenario 1)
            setAnalysisText(responseData.analysisText || "");
            setActionText(responseData.actionText || "");
            setRecommendationText(responseData.recommendationText || "");

            setImplications({
                0: responseData.implication0 || "",
                1: responseData.implication1 || "",
                2: responseData.implication2 || "",
                3: responseData.implication3 || ""
            });

            setPreparedByName(responseData.preparedByName || "");
            setPreparedByDesignation(responseData.preparedByDesignation || "");
            setPreparedByDate(responseData.preparedByDate || "");

            setVerifiedByName(responseData.verifiedByName || "");
            setVerifiedByDesignation(responseData.verifiedByDesignation || "");
            setVerifiedByDate(responseData.verifiedByDate || "");
            setPreparedSignature(responseData.preparedSignature || "");
            setVerifiedSignature(responseData.verifiedSignature || "");

        } catch (error) {
            console.error("Failed to execute data array load workflow sequence:", error);
        } finally {
            setLoading(false);
        }
    };

    // --- SAVE WORKFLOW: DUMMY POST ROUTE METHOD ---
    const handleSaveRiskAssessmentData = async () => {
        setLoading(true);
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            };
            dayjs.extend(customParseFormat);

            const savePayload = {
                Id: documentid === "00000000-0000-0000-0000-000000000000" ? "" : documentid,
                Companyid: companyId,
                Facilityid: data?.hospital?.facilityId || "00000000-0000-0000-0000-000000000000",
                Quater: data?.quarter?.value,
                Year: data?.year?.value,

                // Section 4 Highlights
                Executivehighlightsanalysis: analysisText,
                Executivehighlightsactiontaken: actionText,
                Executivehighlightsrecommendation: recommendationText,

                // Section 4 Implications Grid Row Values
                Ageingsummary: implications[0],
                Highrisksummary: implications[1],
                Highriskpoorconditionsummary: implications[2],
                Quarterrisktrendsummary: implications[3],

                // Signature Profiles
                
                Preparedby : preparedSignature || "",
                Preparedbyname: preparedByName,
                Preparedbydesignation: preparedByDesignation,
                Preparedbydate: preparedByDate ? dayjs(preparedByDate, "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm:ss") || "" : "",

                Reviewedandverifiedby : verifiedSignature || "",
                Reviewedandverifiedbyname: verifiedByName,
                Reviewedandverifiedbydesignation: verifiedByDesignation,
                Reviewedandverifiedbydate: verifiedByDate ? dayjs(verifiedByDate, "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm:ss") || "" : "",
            };


            if (documentid === "00000000-0000-0000-0000-000000000000" || !documentid || documentid === undefined || documentid === null || documentid === "") {
                const endpoint = `${BemsGraph}/api/bemassetriskassessmentreports`;
                const response = await axios.post(endpoint, savePayload, config);
                if (response.status === 200 || response.status === 201) {

                    await fetchchecklist(); // Refresh to ensure data state sync
                }
            } else {
                const endpoint = `${BemsGraph}/api/bemassetriskassessmentreports/${documentid}`;
                const response = await axios.put(endpoint, savePayload, config);

                if (response.status === 200 || response.status === 201) {

                    await fetchchecklist(); // Refresh to ensure data state sync
                }

            }

        }
        catch (error) {
            console.error("Server API dataset execution save operation failure:", error);

        } finally {
            setLoading(false);
        }
    };

    const quarter = quarterObj?.value || "";
    const year = yearObj?.value || "";
    const month = quarterObj?.value === "Q1" ? "JAN - MAR" : quarterObj?.value === "Q2" ? "APR - JUN" : quarterObj?.value === "Q3" ? "JUL - SEPT"
        : quarterObj?.value === "Q4" ? "OCT - DEC" : "All";

    const hospitalName = hospitalObj?.facilityName || hospitalObj?.label || "All";

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    });

    const handleImplicationChange = (index, value) => {
        setImplications(prev => ({ ...prev, [index]: value }));
    };

    const ageingData = [
        { range: "<1", count: riskrowsdata?.assetoneyear || 0, percent: oneyear },
        { range: "1--5", count: riskrowsdata?.assetFive || 0, percent: fiveyear },
        { range: "6--10", count: riskrowsdata?.assetTenyear || 0, percent: tenyear },
        { range: "11--15", count: riskrowsdata?.assetFifteenyear || 0, percent: fifteenyear },
        { range: "16--20", count: riskrowsdata?.asssetTwentyYear || 0, percent: twentyyear },
        { range: ">20", count: riskrowsdata?.assetGreaterthanTwentyYear || 0, percent: greaterthanTwentyYear },
    ];

    const riskData = [
        { level: "High Risk Assets", count: riskrowsdata?.highAssetRiskcount || 0, ratio: highrisk },
        { level: "Moderate Risk Assets", count: riskrowsdata?.moderateAssetRiskcount || 0, ratio: moderaterisk },
        { level: "Low Risk Assets", count: riskrowsdata?.lowAssetRiskcount || 0, ratio: lowrisk },
        { level: "Unidentified Risk Assets", count: riskrowsdata?.undefinedRiskcount || 0, ratio: undefinedrisk },
    ];

    const conditionData = [
        { condition: "High Risk Assets + Good Condition", count: riskrowsdata?.highGoodRiskcount || 0, percent: highconditionrisk },
        { condition: "High Risk Assets + Fair Condition", count: riskrowsdata?.highFairRiskCcount || 0, percent: moderateconditionrisk },
        { condition: "High Risk Assets + Poor Condition", count: riskrowsdata?.highPoorRiskCcount || 0, percent: lowconditionrisk },
        { condition: "Unidentified Asset Condition", count: riskrowsdata?.undefinedAssetConditioncount || 0, percent: undefinedconditionrisk },
    ];

    const summaryData = [
        { indicator: "Aging (≥10 Years)", number: totalassetsummary || 0 },
        { indicator: "Aging (≥10 Years) - High Risk", number: totalconditionsummary || 0 },
        { indicator: "Aging (≥10 Years) - High Risk, Poor Condition", number: riskrowsdata?.highPoorRiskCcount || 0 },
        { indicator: "Quarter-on-Quarter Risk Trend", number: "" },
    ];

    const textfieldStyle = {
        width: '100%',
        minHeight: '120px',
        padding: '12px',
        fontSize: '14px',
        fontFamily: 'inherit',
        lineHeight: '1.6',
        borderRadius: '6px',
        border: '1px solid #ccc',
        backgroundColor: '#fdfdfd',
        resize: 'vertical',
        outline: 'none',
        boxSizing: 'border-box'
    };

    // Multi-page layout calculation split system engine
    const generateConfiguredPDF = (canvas) => {
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pdfWidth = 210;
        const pdfHeight = 294;

        const marginTop = 11;
        const marginBottom = 18;
        const marginLeft = 10;
        const marginRight = 10;

        const printableWidth = pdfWidth - marginLeft - marginRight;
        const printableHeight = pdfHeight - marginTop - marginBottom;

        const canvasPageHeight = (canvas.width * printableHeight) / printableWidth;
        let remainingCanvasHeight = canvas.height;
        let startY = 0;
        let isFirstPage = true;

        while (remainingCanvasHeight > 60) {
            if (!isFirstPage) {
                pdf.addPage();
            }
            isFirstPage = false;

            const chunkHeight = Math.min(remainingCanvasHeight, canvasPageHeight);
            const pageCanvas = document.createElement('canvas');
            pageCanvas.width = canvas.width;
            pageCanvas.height = chunkHeight;

            const context = pageCanvas.getContext('2d');
            if (context) {
                context.drawImage(
                    canvas,
                    0, startY, canvas.width, chunkHeight,
                    0, 0, canvas.width, chunkHeight
                );
            }

            const pageImgData = pageCanvas.toDataURL('image/jpeg', 0.85);
            const outputHeight = (chunkHeight * printableWidth) / canvas.width;

            pdf.addImage(pageImgData, 'JPEG', marginLeft, marginTop, printableWidth, outputHeight);

            startY += chunkHeight;
            remainingCanvasHeight -= chunkHeight;
        }

        return pdf;
    };

    // --- EXPOSED EXECUTABLE HANDLERS TO PARENT COMPONENT CONTEXT ---
    useImperativeHandle(ref, () => ({
        handlePrint() {
            if (typeof handlePrint === 'function') {
                handlePrint();
            } else {
                printRef.current?.focus();
                window.print();
            }
        },

        async handleDownloadPDF() {
            const element = printRef.current;
            if (!element) return;

            const elementsToHide = element.querySelectorAll('.no-print-input');
            elementsToHide.forEach(el => el.style.display = 'none');

            try {
                setLoading(true);
                const canvas = await html2canvas(element, {
                    scale: 2,
                    useCORS: true,
                    logging: false,
                    backgroundColor: "#ffffff"
                });

                elementsToHide.forEach(el => el.style.display = 'block');
                const pdf = generateConfiguredPDF(canvas);
                const safeHospitalName = hospitalName ? hospitalName.replace(/\s+/g, '_') : 'Report';
                pdf.save(`Medical_Device_Risk_Assessment_${safeHospitalName}.pdf`);
            } catch (error) {
                console.error("Local client asset file download canvas trace fail error:", error);
                elementsToHide.forEach(el => el.style.display = 'block');
            } finally {
                setLoading(false);
            }
        },

        async handleSave() {
            // Trigger API save dataset action pipeline
            await handleSaveRiskAssessmentData();
        },

        async handleSubmitToOutlook() {
            const element = printRef.current;
            if (!element) return;

            const elementsToHide = element.querySelectorAll('.no-print-input');
            elementsToHide.forEach(el => el.style.display = 'none');

            try {
                setLoading(true);
                const canvas = await html2canvas(element, {
                    scale: 2,
                    useCORS: true,
                    logging: false,
                    backgroundColor: "#ffffff"
                });

                elementsToHide.forEach(el => el.style.display = 'block');
                const pdf = generateConfiguredPDF(canvas);
                const pdfOutput = pdf.output('datauristring');
                const base64Data = pdfOutput.split(',')[1];

                const boundary = "BEMS_MULTIPART_EMAIL_BOUNDARY_SEPARATOR";
                const emlContent =
                    "X-Unsent: 1\r\n" +
                    "Subject: Medical Risk Report\r\n" +
                    "MIME-Version: 1.0\r\n" +
                    `Content-Type: multipart/mixed; boundary="${boundary}"\r\n\r\n` +
                    `--${boundary}\r\n` +
                    "Content-Type: text/plain; charset=UTF-8\r\n" +
                    "Content-Transfer-Encoding: 7bit\r\n\r\n" +
                    "Hi,\r\n\r\nPlease find the attached Medical Risk Report PDF.\r\n\r\nThanks & Regards\r\n\r\n" +
                    `--${boundary}\r\n` +
                    'Content-Type: application/pdf; name="MedicalRiskReport.pdf"\r\n' +
                    "Content-Transfer-Encoding: base64\r\n" +
                    `Content-Disposition: attachment; filename="MedicalRiskReport.pdf"\r\n\r\n` +
                    base64Data + "\r\n\r\n" +
                    `--${boundary}--`;

                const blob = new Blob([emlContent], { type: "message/rfc822" });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = `${hospitalName}MedicalRiskReport.eml`;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (error) {
                console.error("Outlook pipe failure configuration runtime crash error:", error);
                alert("An error occurred while compiling your report layout into Outlook.");
                elementsToHide.forEach(el => el.style.display = 'block');
            } finally {
                setLoading(false);
            }
        }
    }));

    return (
        <>
            <PageLoader open={loading} />

            <DefaultCard>

                <Box
                    id="capture"
                    ref={printRef}
                    sx={{
                        backgroundColor: '#fff',
                        padding: '30px',
                        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                        color: '#333',
                    }}
                >
                    {/* --- HEADER BLOCK --- */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '4px solid #1a365d', pb: 2, mb: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <img src={reportslogo} alt="IHH Healthcare" style={{ maxWidth: '140px', height: 'auto' }} />
                        </Box>
                        <Box sx={{ textAlign: 'right' }}>
                            <Typography variant="h5" sx={{ fontWeight: '800', color: '#1a365d', letterSpacing: 0.5 }}>
                                MEDICAL DEVICE RISK ASSESSMENT REPORT
                            </Typography>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#c0392b' }}>
                                MONTH: {month} | YEAR {year}
                            </Typography>
                        </Box>
                    </Box>

                    {/* --- HOSPITAL METRICS --- */}
                    <Box sx={{ bgcolor: '#1a4571', color: '#fff', p: 2, borderRadius: '4px', mb: 3 }}>
                        <Typography sx={{ fontWeight: 'bold' }}>HOSPITAL : <span style={{ fontWeight: 'normal' }}>{hospitalName}</span></Typography>
                        <Typography sx={{ fontWeight: 'bold' }}>SERVICE : <span style={{ fontWeight: 'normal' }}>BEMS</span></Typography>
                        <Typography sx={{ fontWeight: 'bold' }}>QUARTER/YEAR : <span style={{ fontWeight: 'normal' }}>{quarter} / {year}</span></Typography>
                    </Box>

                    {/* --- BACKGROUND SECTION --- */}
                    <Box sx={{ border: '2px solid #27ae60', p: 2, borderRadius: '4px', mb: 3 }}>
                        <Typography variant="body2" sx={{ lineHeight: 1.6, color: '#2c3e50' }}>
                            A medical equipment risk assessment by ageing report identifies, analyzes and mitigates potential hazards associated with devices, ensuring compliance with standards. It includes hazard identification, risk evaluation and control measures especially for asset above 10years. Common assessments cover electrical safety, infection control and user error.
                        </Typography>
                    </Box>

                    {/* --- SECTION 1: AGEING ASSETS --- */}
                    <Box sx={{ mb: 4 }}>
                        <Box sx={{ bgcolor: '#2980b9', color: '#fff', px: 2, py: 0.75, fontWeight: 'bold', fontSize: '14px' }}>
                            SECTION 1 : MEDICAL DEVICE AGEING
                        </Box>
                        <Box sx={{ bgcolor: '#d4c9a8', color: '#000', px: 2, py: 0.5, fontWeight: 'bold', fontSize: '14px', mt: '2px' }}>
                            Ageing Exposure Indicator
                        </Box>
                        <Typography variant="body2" sx={{ my: 2, lineHeight: 1.5 }}>
                            As of the reporting quarter, a significant proportion of the medical device portfolio is entering the late lifecycle phase (≥10 years).
                        </Typography>

                        <TableContainer component={Paper} elevation={1} sx={{ maxWidth: 500 }}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ bgcolor: '#c0392b' }}>
                                        <TableCell sx={{ color: '#fff', fontWeight: 'bold', textAlign: 'center' }}>YEARS</TableCell>
                                        <TableCell sx={{ color: '#fff', fontWeight: 'bold', textAlign: 'center' }}>NUMBER OF ASSET</TableCell>
                                        <TableCell sx={{ color: '#fff', fontWeight: 'bold', textAlign: 'center' }}>%</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {ageingData.map((row, index) => (
                                        <TableRow key={index} sx={{ bgcolor: index % 2 === 0 ? '#2c2541' : '#fff' }}>
                                            <TableCell sx={{ color: index % 2 === 0 ? '#fff' : '#000', fontWeight: 'bold', textAlign: 'center', borderRight: '1px solid #e0e0e0' }}>{row.range}</TableCell>
                                            <TableCell sx={{ color: index % 2 === 0 ? '#fff' : '#000', textAlign: 'center', borderRight: '1px solid #e0e0e0' }}>{row.count}</TableCell>
                                            <TableCell sx={{ color: index % 2 === 0 ? '#fff' : '#000', textAlign: 'center' }}>{row.percent}</TableCell>
                                        </TableRow>
                                    ))}
                                    <TableRow sx={{ bgcolor: '#c0392b' }}>
                                        <TableCell sx={{ color: '#fff', fontWeight: 'bold', textAlign: 'center' }}>TOTAL</TableCell>
                                        <TableCell sx={{ color: '#fff', fontWeight: 'bold', textAlign: 'center' }}>{totalassetage}</TableCell>
                                        <TableCell sx={{ color: '#fff', fontWeight: 'bold', textAlign: 'center' }}>100 %</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                    {/* --- SECTION 2: RISK LEVEL DASHBOARD --- */}
                    <Box sx={{ mb: 4 }}>
                        <Box sx={{ bgcolor: '#2980b9', color: '#fff', px: 2, py: 0.75, fontWeight: 'bold', fontSize: '14px' }}>
                            {"SECTION 2 : ≥ 10 ASSET RISK DASHBOARD (Summary)"}
                        </Box>
                        <Box sx={{ bgcolor: '#d4c9a8', color: '#000', px: 2, py: 0.5, fontWeight: 'bold', fontSize: '14px', mt: '2px' }}>
                            A. Risk Distribution based on formula:
                        </Box>
                        <br />

                        <TableContainer component={Paper} elevation={1} sx={{ maxWidth: 650 }}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ bgcolor: '#c0392b' }}>
                                        <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Medical Asset Risk Level</TableCell>
                                        <TableCell sx={{ color: '#fff', fontWeight: 'bold', textAlign: 'center' }}>Count</TableCell>
                                        <TableCell sx={{ color: '#fff', fontWeight: 'bold', textAlign: 'center' }}>Ratio %</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {riskData.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell sx={{ fontWeight: '500', borderRight: '1px solid #e0e0e0' }}>{row.level}</TableCell>
                                            <TableCell sx={{ textAlign: 'center', borderRight: '1px solid #e0e0e0' }}>{row.count}</TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>{row.ratio}</TableCell>
                                        </TableRow>
                                    ))}
                                    <TableRow sx={{ bgcolor: '#c0392b' }}>
                                        <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Total Biomedical Assets</TableCell>
                                        <TableCell sx={{ color: '#fff', fontWeight: 'bold', textAlign: 'center' }}>{totalassetsummary}</TableCell>
                                        <TableCell sx={{ color: '#fff', fontWeight: 'bold', textAlign: 'center' }}>100%</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                    {/* --- SECTION 3: ASSET CONDITION DASHBOARD --- */}
                    <Box sx={{ mb: 4 }}>
                        <Box sx={{ bgcolor: '#1a4571', color: '#fff', px: 2, py: 0.75, fontWeight: 'bold', fontSize: '14px' }}>
                            {`SECTION 3 : ≥ 10 ASSET CONDITION DASHBOARD (High Risk Asset Only)`}
                        </Box>
                        <Box sx={{ bgcolor: '#d4c9a8', color: '#000', px: 2, py: 0.5, fontWeight: 'bold', fontSize: '14px', mt: '2px' }}>
                            B. Aging High-Risk Medical Device - Condition Status Review
                        </Box>

                        <TableContainer component={Paper} elevation={1} sx={{ maxWidth: 650, mt: 2 }}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ bgcolor: '#c0392b' }}>
                                        <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Asset Condition</TableCell>
                                        <TableCell sx={{ color: '#fff', fontWeight: 'bold', textAlign: 'center' }}>No. of Assets</TableCell>
                                        <TableCell sx={{ color: '#fff', fontWeight: 'bold', textAlign: 'center' }}>Percentage %</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {conditionData.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell sx={{ fontWeight: '500', borderRight: '1px solid #e0e0e0' }}>{row.condition}</TableCell>
                                            <TableCell sx={{ textAlign: 'center', borderRight: '1px solid #e0e0e0' }}>{row.count}</TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>{row.percent}</TableCell>
                                        </TableRow>
                                    ))}
                                    <TableRow sx={{ bgcolor: '#c0392b' }}>
                                        <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Total High Risk Biomedical Assets</TableCell>
                                        <TableCell sx={{ color: '#fff', fontWeight: 'bold', textAlign: 'center' }}>{totalconditionsummary}</TableCell>
                                        <TableCell sx={{ color: '#fff', fontWeight: 'bold', textAlign: 'center' }}>100%</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                    {/* --- SECTION 4: SUMMARY MATRIX CONTROLS --- */}
                    <Box sx={{ bgcolor: '#1a4571', color: '#fff', px: 2, py: 0.75, fontWeight: 'bold', fontSize: '14px', mb: 2 }}>
                        SECTION 4 : SUMMARY
                    </Box>

                    <TableContainer component={Paper} elevation={1} sx={{ mb: 2 }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow sx={{ bgcolor: '#d4c9a8' }}>
                                    <TableCell sx={{ color: '#000', fontWeight: 'bold', width: '30%' }}>Indicator</TableCell>
                                    <TableCell sx={{ color: '#000', fontWeight: 'bold', textAlign: 'center', width: '25%' }}>Number Observation</TableCell>
                                    <TableCell sx={{ color: '#000', fontWeight: 'bold', textAlign: 'center', width: '55%' }}>Implication</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {summaryData.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell sx={{ fontWeight: '500', borderRight: '1px solid #e0e0e0', py: 1.5 }}>{row.indicator}</TableCell>
                                        <TableCell sx={{ textAlign: 'center', borderRight: '1px solid #e0e0e0' }}>{row.number}</TableCell>
                                        <TableCell sx={{ p: 1 }}>
                                            <textarea
                                                style={{
                                                    width: '100%', minHeight: '60px', height: 'auto', padding: '6px 10px',
                                                    fontSize: '13px', fontFamily: 'inherit', lineHeight: '1.4', borderRadius: '4px',
                                                    border: '1px solid #ccc', backgroundColor: '#fdfdfd', resize: 'none', outline: 'none',
                                                    boxSizing: 'border-box', overflowY: 'hidden'
                                                }}
                                                disabled={editform}
                                                value={implications[index] !== undefined ? implications[index] : ""}
                                                onChange={(e) => {
                                                    handleImplicationChange(index, e.target.value);
                                                    e.target.style.height = 'auto';
                                                    e.target.style.height = `${e.target.scrollHeight}px`;
                                                }}
                                                ref={(el) => {
                                                    if (el) {
                                                        el.style.height = 'auto';
                                                        el.style.height = `${el.scrollHeight}px`;
                                                    }
                                                }}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* --- EXECUTIVE HIGHLIGHT BINDINGS --- */}
                    <Box sx={{ mb: 2 }}>
                        <Box sx={{ bgcolor: '#1a4571', color: '#fff', px: 2, py: 0.75, fontWeight: 'bold', fontSize: '14px', mb: 2 }}>
                            SECTION 4 : EXECUTIVE HIGHLIGHT
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, px: 1, mt: 3 }}>
                            <Box>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#000', mb: 0.5 }}>Analysis</Typography>
                                <textarea
                                    style={{ ...textfieldStyle, resize: 'none', overflowY: 'hidden', height: 'auto', minHeight: '80px' }}
                                    disabled={editform}
                                    value={analysisText}
                                    onChange={(e) => {
                                        setAnalysisText(e.target.value);
                                        e.target.style.height = 'auto';
                                        e.target.style.height = `${e.target.scrollHeight}px`;
                                    }}
                                    ref={(el) => {
                                        if (el) { el.style.height = 'auto'; el.style.height = `${el.scrollHeight}px`; }
                                    }}
                                    maxLength={500}
                                />
                            </Box>
                            <Box>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#000', mb: 0.5 }}>Action Taken :</Typography>
                                <textarea
                                    style={{ ...textfieldStyle, resize: 'none', overflowY: 'hidden', height: 'auto', minHeight: '80px' }}
                                    disabled={editform}
                                    value={actionText}
                                    onChange={(e) => {
                                        setActionText(e.target.value);
                                        e.target.style.height = 'auto';
                                        e.target.style.height = `${e.target.scrollHeight}px`;
                                    }}
                                    ref={(el) => {
                                        if (el) { el.style.height = 'auto'; el.style.height = `${el.scrollHeight}px`; }
                                    }}
                                    maxLength={500}
                                />
                            </Box>
                            <Box>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#000', mb: 0.5 }}>Recommendation :</Typography>
                                <textarea
                                    style={{ ...textfieldStyle, resize: 'none', overflowY: 'hidden', height: 'auto', minHeight: '80px' }}
                                    value={recommendationText}
                                    disabled={editform}
                                    onChange={(e) => {
                                        setRecommendationText(e.target.value);
                                        e.target.style.height = 'auto';
                                        e.target.style.height = `${e.target.scrollHeight}px`;
                                    }}
                                    ref={(el) => {
                                        if (el) { el.style.height = 'auto'; el.style.height = `${el.scrollHeight}px`; }
                                    }}
                                    maxLength={500}
                                />
                            </Box>
                        </Box>
                    </Box>

                    {/* --- SIGNATURE DATA CAPTURE AND CORRECTION FIELD BINDINGS --- */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 8, pt: 2, px: 1 }}>

                        {/* Prepared By Section */}
                        <Box sx={{ width: '45%' }}>
                            <Typography variant="body2" sx={{ color: '#333', mb: 1.5 }}>Prepared by :</Typography>
                            <SignaturePad
                                value={preparedSignature}
                                onChange={(val) => setPreparedSignature(val)}
                                disabled={editform}
                            />
                            <Box sx={{ borderBottom: '1px solid #333', mb: 1, mt: 1 }} />
                            <Typography variant="caption" display="block" sx={{ color: '#555', mb: 1 }}>(Signature)</Typography>
                            <Box sx={{ display: 'grid', gridTemplateColumns: 'auto auto 1fr', rowGap: 1, columnGap: 1.5, alignItems: 'center' }}>
                                <Typography variant="body2" sx={{ fontWeight: '500', minWidth: '90px' }}>Name</Typography>
                                <Typography variant="body2">:</Typography>
                                <Input
                                    slotProps={{ input: { readOnly: editform } }}
                                    disableUnderline
                                    value={preparedByName}
                                    onChange={(e) => setPreparedByName(e.target.value)}
                                    sx={{ fontWeight: '500', fontSize: '14px', width: '100%', input: { padding: 0 } }}
                                />

                                <Typography variant="body2" sx={{ fontWeight: '500', minWidth: '90px' }}>Designation</Typography>
                                <Typography variant="body2">:</Typography>
                                <Input
                                    slotProps={{ input: { readOnly: editform } }}
                                    disableUnderline
                                    value={preparedByDesignation}
                                    onChange={(e) => setPreparedByDesignation(e.target.value)}
                                    sx={{ fontWeight: '500', fontSize: '14px', width: '100%', input: { padding: 0 } }}
                                />

                                <Typography variant="body2" sx={{ fontWeight: '500', minWidth: '90px' }}>Date</Typography>
                                <Typography variant="body2">:</Typography>
                                <Input
                                    slotProps={{ input: { readOnly: editform } }}
                                    placeholder="DD/MM/YYYY"
                                    disableUnderline
                                    value={preparedByDate}
                                    onChange={(e) => setPreparedByDate(e.target.value)}
                                    sx={{ fontWeight: '500', fontSize: '14px', width: '100%', input: { padding: 0 } }}
                                />
                            </Box>
                        </Box>

                        {/* Verified By Section */}
                        <Box sx={{ width: '45%' }}>
                            <Typography variant="body2" sx={{ color: '#333', mb: 1.5 }}>Reviewed and Verified by :</Typography>
                            <SignaturePad
                                value={verifiedSignature}
                                onChange={(val) => setVerifiedSignature(val)}
                                disabled={editform}
                            />
                            <Box sx={{ borderBottom: '1px solid #333', mb: 1, mt: 1 }} />
                            <Typography variant="caption" display="block" sx={{ color: '#555', mb: 1 }}>(Signature)</Typography>
                            <Box sx={{ display: 'grid', gridTemplateColumns: 'auto auto 1fr', rowGap: 1, columnGap: 1.5, alignItems: 'center' }}>
                                <Typography variant="body2" sx={{ fontWeight: '500', minWidth: '90px' }}>Name</Typography>
                                <Typography variant="body2">:</Typography>
                                <Input
                                    slotProps={{ input: { readOnly: editform } }}
                                    disableUnderline
                                    value={verifiedByName}
                                    onChange={(e) => setVerifiedByName(e.target.value)}
                                    sx={{ fontWeight: '500', fontSize: '14px', width: '100%', input: { padding: 0 } }}
                                />

                                <Typography variant="body2" sx={{ fontWeight: '500', minWidth: '90px' }}>Designation</Typography>
                                <Typography variant="body2">:</Typography>
                                <Input
                                    slotProps={{ input: { readOnly: editform } }}
                                    disableUnderline
                                    value={verifiedByDesignation}
                                    onChange={(e) => setVerifiedByDesignation(e.target.value)}
                                    sx={{ fontWeight: '500', fontSize: '14px', width: '100%', input: { padding: 0 } }}
                                />

                                <Typography variant="body2" sx={{ fontWeight: '500', minWidth: '90px' }}>Date</Typography>
                                <Typography variant="body2">:</Typography>
                                <Input
                                    slotProps={{ input: { readOnly: editform } }}
                                    placeholder="DD/MM/YYYY"
                                    disableUnderline
                                    value={verifiedByDate}
                                    onChange={(e) => setVerifiedByDate(e.target.value)}
                                    sx={{ fontWeight: '500', fontSize: '14px', width: '100%', input: { padding: 0 } }}
                                />
                            </Box>
                        </Box>
                    </Box>

                </Box>
            </DefaultCard>
        </>
    );
});

export default ViewAssetMedicalRiskManagment;